<template>
  <v-flex class="home-goal-block">
    <v-card-title class="card-title">
      Home Goals
      <span @click="showModal = true">UPDATE GOALS</span>
    </v-card-title>
    <v-card-text v-if="profile" class="goal-info">
      <v-flex class="goal-info-container">
        <span>Goal Date</span>
        <span>{{ formatDate(profile.goalDate) || "N/A" }}</span>
      </v-flex>
      <v-flex class="goal-info-container">
        <span>Price Range</span>
        <span>{{ getPriceRange }}</span>
      </v-flex>
    </v-card-text>
    <default-modal
      :show-modal="showModal"
      :width="'470px'"
      :modal-title="'Update Information'"
      @close-modal="showModal = false"
    >
      <update-client-details
        @close-modal="showModal = false"
      />
    </default-modal>
  </v-flex>
</template>
<script>
import UpdateClientDetails from '../../components/client-detail/UpdateClientDetails'
import DefaultModal from '../../components/modals/DefaultModal'
import colors from '../../scss/_colors.scss'
import { updateMyProfile } from '../../services/profile'
import { mapMutations } from 'vuex'
import moment from 'moment'
import currencyFormatter from 'currency-formatter'
export default {
  components: {
    UpdateClientDetails,
    DefaultModal
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      profileForm: {
        goalDate: '',
        priceMin: '',
        priceMax: ''
      },
      showModal: false,
      colors
    }
  },

  computed: {
    getPriceRange() {
      return this.profile.hasOwnProperty('priceMin') && this.profile.priceMax
        ? `${this.formatPrice(this.profile.priceMin)} - ${this.formatPrice(
          this.profile.priceMax
        )}`
        : 'N/A'
    }
  },

  watch: {
    profile() {
      this.mapData()
    }
  },
  created() {
    this.mapData()
  },
  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    mapData() {
      for (let key in this.profileForm) {
        if (this.profile && this.profile[key]) {
          this.profileForm[key] = this.profile[key]
        }
      }
    },
    formatDate(date) {
      if (!date) return null
      return moment(date).format('MMMM, YYYY')
    },
    formatPrice(price) {
      return currencyFormatter.format(price, { code: 'USD' }).slice(0, -3)
    },
    async updateInfo() {
      const updatedPersonalInfo = await updateMyProfile(this.profileForm)
      this.setClientData(updatedPersonalInfo.data)
      this.showModal = false
    }
  }
}
</script>
<style lang="sass">
.agent-data-container
  input[type=password]
      border: 1px solid $color-grey
      height: 40px
      width:  100%
      margin: 1rem 0 2rem
      padding-left: 15px
.logout-container
  display: flex
  justify-content: flex-start
  align-items: center
  margin-bottom: 1rem
  span
    display: block
  input
    margin-right: 15px
    width: 15px
    height: 15px
.goal-info
  display: flex
  justify-content: flex-start
  align-items: flex-start
  text-align: left
  flex-direction: column
  padding: 0 16px 16px !important
.goal-info input[type=password]
  border: none
  height: 10px
.goal-info-container
  display: flex
  flex-direction: column
.goal-info-container:last-child
  padding: 1rem 0
.goal-info-container span:first-child
  font-weight: 450 !important
  padding: 0.7rem 0
</style>
